import { route } from 'quasar/wrappers';
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from 'vue-router';
import { useApplicationStore } from 'stores/application';
import { useAccountStore } from 'stores/account';
import { storeToRefs } from 'pinia';
import routes from './routes';
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route((/* { store, ssrContext } */) => {
  const applicationStore = useApplicationStore();
  const { isBooting } = storeToRefs(applicationStore);
  const accountStore = useAccountStore();
  const { isAdmin, details: userDetails } = storeToRefs(accountStore);

  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory);

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach((to, from, next) => {
    // Require authentication
    if (to.meta?.needsAuth
      && to.name !== 'Authentication'
      && !userDetails.value
      && !isBooting.value) {
      next({ name: 'Authentication' });
    }
    // Require admin
    else if (to.meta?.needsAdmin
      && !isAdmin
      && !isBooting.value) {
      next({ name: 'Home' });
    }
    else {
      next();
    }
  });

  return Router;
});
